<div class="full-screen-bg">
	<div *ngIf="loadershow" class="loader text-center">
		<img src="../assets/img/loading.gif" />
	</div>
	<div class="container container-sm">
		<div class="row">
			<div class="col-lg-3 col-md-3 col-sm-1  col-xs-1"></div>
			<div class="col-lg-6 col-md-6 col-sm-10  col-xs-10">
				<div class="card mt-4">
					<div class="card-header bg-logo text-center mb-4">
						<img src="../assets/img/3Cube-White.png" alt="Image" width="130px" />
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col">
								<div class="card warning-border">
									<div class="card-body warning-message">
										<strong>
											Duty of Care Acknowledgment
										</strong>
										<p class="mb-0">
											{{acknowledgment}}
										</p>
									</div>
								</div>
							</div>
						</div>
						<div class="row px-3" *ngIf="step == 1">
							<div class="col">
								<form role="form" (ngSubmit)="submitForm(user)">
									<div class="row mt-2">
										<div class="col">
											<div class="input-group mb-3">
												<span class="input-group-text"><fa-icon
														[icon]="['fas', 'user']"></fa-icon></span>
												<input type="text" class="form-control" placeholder="Username"
													aria-label="Username" aria-describedby="basic-addon1"
													[(ngModel)]="user.email" [ngModelOptions]="{standalone: true}">
											</div>
										</div>
									</div>
									<div class="row mt-2">
										<div class="col">
											<div class="input-group mb-3">
												<span class="input-group-text"><fa-icon
														[icon]="['fas', 'lock']"></fa-icon></span>
												<input type="password" class="form-control" placeholder="Password"
													aria-label="Password" aria-describedby="basic-addon1"
													[(ngModel)]="user.password" [ngModelOptions]="{standalone: true}">
											</div>
										</div>

									</div>
									<div class="row mt-2">
										<div class="col text-center">
											<button type="submit" class="btn login-btn w-100">
												Log In Securely
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
						<div class="row px-3" *ngIf="step == 2">
							<div class="col" *ngIf="qrStep == 1">
								<div class="row">
									<div class="col-9">
										<h3>Set Up Google Authenticator App</h3>
										<h4>
											<div class="my-circle">1</div>
											Download an App
										</h4>
										<p class="px-3">
											Download the Google Authenticator App from&nbsp;
											<a href="https://play.google.com" target="_blank">
												Google Play Store
											</a>
											&nbsp;or&nbsp;
											<a href="https://apps.apple.com" target="_blank">App Store.</a>
										</p>
									</div>
									<div class="col text-center">
										<div class="app-icon-container">
											<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
												target="_blank" class="mt-4">
												<img src="../assets/img/get_it_on_google_play.png"
													class="w-75 h-auto" />
											</a>
											<a href="https://apps.apple.com/us/app/google-authenticator/id388497605"
												target="_blank">
												<img src="../assets/img/download_on_app_store.png"
													class="mt-2 w-75  h-auto" />
											</a>
										</div>
										<button type="button" class="btn btn-success my-2 w-100" (click)="next()">
											I Have An App
										</button>
									</div>
								</div>
							</div>
							<div class="col" *ngIf="qrStep == 2">
								<form role="form" (ngSubmit)="verifyOTP()">
									<div class="row" *ngIf="showQR">

										<div class="col-9">
											<h3>Set Up Google Authenticator App</h3>
											<h4>
												<div class="my-circle">2</div>Add Your Account
											</h4>
											<p class="ps-30">
												Scan the QR code to get the code you will need to complete the
												verification
												in
												step 3 and to verify future logins.
											</p>
											<h4>
												<div class="my-circle">3</div>Verify Your Account
											</h4>
											<p class="ps-30">
												Enter the 6 digit code provided from your authenticator app.
											</p>
										</div>
										<div class="col text-center">
											<img src="{{qrToShow}}" alt="QR Code" class="w-100 h-auto" />
										</div>
									</div>
									<div class="row my-2">
										<div class="col">
											<div class="input-group mb-3">
												<span class="input-group-text">Code</span>
												<input type="text" class="form-control" placeholder="Enter Code"
													aria-label="otp" aria-describedby="basic-addon1"
													[(ngModel)]="auth.otp" [ngModelOptions]="{standalone: true}"
													required>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<button type="submit" class="btn btn-success w-100">
												Verify
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-sm-12 text-center fw-bold mt-1">
								&nbsp;&copy; {{year}}&nbsp;
								<a href="http://3cubeservices.com/" target="_blank">
									3CUBE
								</a>
							</div>
						</div>
						<div class="row my-1" *ngIf="loginErrorshow">
							<div class="col">
								<div class="alert alert-danger text-center" role="alert">
									<label>{{loginFormErr}}</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-1  col-xs-1"></div>
		</div>
	</div>
</div>